import activityReducer from './activity.reducer'

export default activityReducer
